import { Element } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { PseudoClassSelector } from "./pseudo-class.js";
const { isElement } = Element;
const { not } = Predicate;
/**
 * {@link https://drafts.csswg.org/selectors/#root-pseudo}
 */
export class Root extends PseudoClassSelector {
    static of() {
        return new Root();
    }
    constructor() {
        super("root");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        // The root element is the element whose parent is NOT itself an element.
        return element.parent().every(not(isElement));
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Root) {
    Root.parse = PseudoClassSelector.parseNonFunctional("root", Root.of);
})(Root || (Root = {}));
//# sourceMappingURL=root.js.map